var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.displayProgress)?_c('v-progress-linear',{staticClass:"drying-card-row mt-1 me-3",attrs:{"background-color":_vm.trackColor,"color":_vm.color,"value":_vm.progress,"height":"15px"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }